import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-01832f21")

_pushScopeId("data-v-01832f21")
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", null, "카테고리", -1)
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/_createVNode("label", null, "제목", -1)
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", null, "소개글", -1)
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", null, "브랜드", -1)
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", null, "미리보기 URL", -1)
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = /*#__PURE__*/_createVNode("label", null, "앱 url", -1)
const _hoisted_17 = { class: "form-group grid" }
const _hoisted_18 = /*#__PURE__*/_createVNode("label", null, "내용", -1)
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-md-4" }
const _hoisted_22 = /*#__PURE__*/_createVNode("label", null, "매거진 노출", -1)
const _hoisted_23 = { class: "form-group mb-3" }
const _hoisted_24 = { class: "c-switch c-switch-pill c-switch-primary" }
const _hoisted_25 = /*#__PURE__*/_createVNode("span", { class: "c-switch-slider" }, null, -1)
const _hoisted_26 = { class: "col-md-4" }
const _hoisted_27 = /*#__PURE__*/_createVNode("label", null, "조회수 표시", -1)
const _hoisted_28 = { class: "form-group mb-3" }
const _hoisted_29 = { class: "c-switch c-switch-pill c-switch-primary" }
const _hoisted_30 = /*#__PURE__*/_createVNode("span", { class: "c-switch-slider" }, null, -1)
const _hoisted_31 = { class: "col-md-4" }
const _hoisted_32 = /*#__PURE__*/_createVNode("label", null, "화면 좌우 여백 없애기", -1)
const _hoisted_33 = { class: "form-group mb-3" }
const _hoisted_34 = { class: "c-switch c-switch-pill c-switch-primary" }
const _hoisted_35 = /*#__PURE__*/_createVNode("span", { class: "c-switch-slider" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_editor = _resolveComponent("editor")
  const _component_file_upload = _resolveComponent("file-upload")
  const _component_SubmitButton = _resolveComponent("SubmitButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("form", {
        onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"])),
        class: { loading: _ctx.loading }
      }, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _hoisted_6,
              _withDirectives(_createVNode("select", {
                class: "form-control",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.jin.category_id = $event)),
                required: ""
              }, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.jinCategories, (jinCategory) => {
                  return (_openBlock(), _createBlock("option", {
                    key: jinCategory.id,
                    value: jinCategory.id
                  }, _toDisplayString(jinCategory.name), 9, ["value"]))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.jin.category_id]
              ])
            ]),
            _createVNode("div", _hoisted_7, [
              _hoisted_8,
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.jin.title = $event))
              }, null, 512), [
                [_vModelText, _ctx.jin.title]
              ])
            ]),
            _createVNode("div", _hoisted_9, [
              _hoisted_10,
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.jin.summary = $event))
              }, null, 512), [
                [_vModelText, _ctx.jin.summary]
              ])
            ]),
            _createVNode("div", _hoisted_11, [
              _hoisted_12,
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.jin.brand = $event))
              }, null, 512), [
                [_vModelText, _ctx.jin.brand]
              ])
            ]),
            _createVNode("div", _hoisted_13, [
              _hoisted_14,
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.jin.contents_url = $event))
              }, null, 512), [
                [_vModelText, _ctx.jin.contents_url]
              ])
            ]),
            _createVNode("div", _hoisted_15, [
              _hoisted_16,
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.jin.landing_url = $event))
              }, null, 512), [
                [_vModelText, _ctx.jin.landing_url]
              ])
            ]),
            _createVNode("div", _hoisted_17, [
              _hoisted_18,
              _createVNode(_component_editor, {
                ref: "customEditor",
                "set-contents": _ctx.editorContent ?? ''
              }, null, 8, ["set-contents"])
            ]),
            _createVNode("div", _hoisted_19, [
              _createVNode(_component_file_upload, {
                title: "Thumbnail",
                ref: "thumbnailFile",
                "folder-name": 'jin',
                setPreviewImg: _ctx.jin.thumbnail
              }, null, 8, ["setPreviewImg"])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_20, [
          _createVNode("div", _hoisted_21, [
            _hoisted_22,
            _createVNode("div", _hoisted_23, [
              _createVNode("label", _hoisted_24, [
                _withDirectives(_createVNode("input", {
                  type: "checkbox",
                  class: "c-switch-input",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.jin.show = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.jin.show]
                ]),
                _hoisted_25
              ])
            ])
          ]),
          _createVNode("div", _hoisted_26, [
            _hoisted_27,
            _createVNode("div", _hoisted_28, [
              _createVNode("label", _hoisted_29, [
                _withDirectives(_createVNode("input", {
                  type: "checkbox",
                  class: "c-switch-input",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.jin.show_view_count = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.jin.show_view_count]
                ]),
                _hoisted_30
              ])
            ])
          ]),
          _createVNode("div", _hoisted_31, [
            _hoisted_32,
            _createVNode("div", _hoisted_33, [
              _createVNode("label", _hoisted_34, [
                _withDirectives(_createVNode("input", {
                  type: "checkbox",
                  class: "c-switch-input",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.jin.no_margin_layout = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.jin.no_margin_layout]
                ]),
                _hoisted_35
              ])
            ])
          ])
        ]),
        _createVNode(_component_SubmitButton, {
          text: "저장",
          loadingText: " Saving...",
          isSubmitting: _ctx.isSubmitting
        }, null, 8, ["isSubmitting"])
      ], 34)
    ])
  ]))
})